import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { IAsset } from "../../../../../features/file-attachments/types/file-attachment.interface";

export enum WorkOrderAssetsTabActions {
  FetchAssets = "WorkOrderAssets/Fetch",
  FetchAssetsSuccess = "WorkOrderAssets/FetchSuccess",
  FetchAssetsFailure = "WorkOrderAssets/FetchFailure",

  SetAssets = "WorkOrderAssets/SetAssets",

  UploadAssets = "WorkOrderAssets/Upload",
  UploadAssetsSuccess = "WorkOrderAssets/UploadSuccess",
  UploadAssetsFailure = "WorkOrderAssets/UploadFailure",

  DeleteAsset = "WorkOrderAssets/Delete",
  DeleteAssetSuccess = "WorkOrderAssets/DeleteSuccess",
  DeleteAssetFailure = "WorkOrderAssets/DeleteFailure",

  Reset = "WorkOrderAssets/Reset",
}

export const fetchAssets = (workOrderId: number) =>
  action(WorkOrderAssetsTabActions.FetchAssets, workOrderId);
export const fetchAssetsSuccess = (assets: IAsset[]) =>
  action(WorkOrderAssetsTabActions.FetchAssetsSuccess, assets);
export const fetchAssetsFailure = (error: IError) =>
  action(WorkOrderAssetsTabActions.FetchAssetsFailure, error);

export const setAssets = (assets: IAsset[]) => action(WorkOrderAssetsTabActions.SetAssets, assets);

export const uploadAssets = (files: File[]) =>
  action(WorkOrderAssetsTabActions.UploadAssets, files);
export const uploadAssetsSuccess = (assets: IAsset[]) =>
  action(WorkOrderAssetsTabActions.UploadAssetsSuccess, assets);
export const uploadAssetsFailure = (error: IError) =>
  action(WorkOrderAssetsTabActions.UploadAssetsFailure, error);

export const deleteAsset = (assetId: number) =>
  action(WorkOrderAssetsTabActions.DeleteAsset, assetId);
export const deleteAssetSuccess = (assetId: number) =>
  action(WorkOrderAssetsTabActions.DeleteAssetSuccess, assetId);
export const deleteAssetFailure = (error: IError) =>
  action(WorkOrderAssetsTabActions.DeleteAssetFailure, error);

export const reset = () => action(WorkOrderAssetsTabActions.Reset);

const actionCreators = {
  fetchAssets,
  fetchAssetsSuccess,
  fetchAssetsFailure,
  uploadAssets,
  uploadAssetsSuccess,
  uploadAssetsFailure,
  deleteAsset,
  deleteAssetSuccess,
  deleteAssetFailure,
  setAssets,
  reset,
};

export type WorkOrderAssetsTabActionType = ActionType<typeof actionCreators>;
